const c = {
  mounted(a, i) {
    const t = i.value;
    if (!t)
      return;
    const n = [], l = (o) => {
      for (const e of Array.from(o))
        window.CSSPropertyRule && e instanceof CSSPropertyRule && n.push({
          name: e.name,
          initialValue: e.initialValue || "initial"
        });
    };
    if (t.styleSheets && Array.from(t.styleSheets).forEach((o) => {
      l(o.cssRules);
    }), n.length > 0) {
      const e = `
        *,
        :before,
        :after,
        ::backdrop {
          ${n.map((s) => `  ${s.name}: ${s.initialValue};`).join(`
`)}
        }
      `.trim(), r = document.createElement("style");
      r.id = "shadow-property-polyfill", r.textContent = e, t.prepend(r);
    }
  }
};
export {
  c as vShadowPropertyPolyfill
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/utils/vShadowPropertyPolyfill.js
// module id = 208
// module chunks = 41